import './App.css';
import Home from './Components/Home/Home/Home';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import WorkSummary from './Components/Home/WorkSummary/WorkSummary';
import About from './Components/Home/About/About';
import Project from './Components/Home/Project/Project';
import ContactMe from './Components/Home/ContactMe/ContactMe';
import NotMatch from './Components/NotMatch/NotMatch';
import Header from './Components/Home/Header/Header';
import Services from './Components/Home/Service/Service';
import ServiceDetails from './Components/Home/Service/ServiceDetails/ServiceDetails';
import AllProject from './Components/Project/AllProject/AllProject';
import BlogDetails from './Components/Home/BlogDetails/BlogDetails';
import Sidebar from './Components/Home/Sidebar/Sidebar';
import MainProjectData from './Components/MainProject/MainProjectData/MainProjectData';
function App() {
  return (

    <Router>
      <Header></Header>
      <Sidebar></Sidebar>
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route path="/home">
          <Home></Home>
        </Route>
        <Route path="/work">
          <WorkSummary></WorkSummary>
        </Route>
        <Route path="/about">
          <About></About>
        </Route>
        <Route path="/allBlog">
          <BlogDetails></BlogDetails>
        </Route>
        <Route path="/project">
          <Project></Project>
        </Route>
        <Route path="/allProject">
          <AllProject></AllProject>
        </Route>
        <Route path="/mainProject">
          <MainProjectData></MainProjectData>
        </Route>
        <Route path="/contact">
          <ContactMe></ContactMe>
        </Route>
        <Route path="/service">
          <Services></Services>
        </Route>
        <Route path="/serviceDetails">
          <ServiceDetails></ServiceDetails>
        </Route>

        <Route path="*">
          <NotMatch></NotMatch>
        </Route>
      </Switch>
    </Router>
    // </div>
  );
}

export default App;
